import React, { useEffect } from 'react';
import Box from '@amzn/meridian/box';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import TaskConfigurationTabGroup from './taskConfigurationTabGroup/taskConfigurationTabGroup';
import Tasks from './tasks/tasks';
import TaskGroups from './taskGroups/taskGroups';
import { ADMIN_CONFIG_TASK_TABS } from 'src/store/adminConfigPageSlice/common/constants';
import {
  fetchMeasureUnits,
  fetchRegions,
  fetchTaskGroups,
  fetchTasks,
  setTaskSearchFieldValue,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import './taskConfiguration.scss';

// **** Components **** //

/**
 * Default Component
 */
const TaskConfiguration = () => {
  const dispatch = useAppDispatch();
  const { featureFlags, userLoading, isFeatureFlagsLoaded } = useAppSelector((state) => state.user);

  // Fetch back-end data
  useEffect(() => {
    if (userLoading === 'fulfilled' && isFeatureFlagsLoaded) {
      dispatch(fetchMeasureUnits());
      dispatch(fetchTasks());
      dispatch(fetchRegions());
      if (featureFlags.TASK_GROUPING) {
        dispatch(fetchTaskGroups());
      }
    }
    return () => {
      dispatch(setTaskSearchFieldValue(''));
    };
  }, [userLoading, isFeatureFlagsLoaded]);

  return <div>{featureFlags.TASK_GROUPING ? <TaskConfigurationTabs /> : <Tasks />}</div>;
};

/**
 * TaskConfiguration Tabs
 */
const TaskConfigurationTabs = () => {
  const { selectedTaskTab } = useAppSelector((state) => state.adminConfigPage);
  return (
    <div>
      <Box spacingInset="500 none none none">
        <TaskConfigurationTabGroup />
      </Box>
      <Box type="outline" spacingInset="200 500 400 500">
        {selectedTaskTab === ADMIN_CONFIG_TASK_TABS.Task ? (
          <Tasks />
        ) : selectedTaskTab === ADMIN_CONFIG_TASK_TABS.TaskGroup ? (
          <TaskGroups />
        ) : null}
      </Box>
    </div>
  );
};

// **** Export **** //

export default TaskConfiguration;
